// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class IsochroneArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.IsochroneArgs';
  $t: string = 'SagaBase.IsochroneArgs';

  public static GetMembers(): string[] {
    return ['Points', 'Duration', 'EnableTraffic', 'ProjCode'];
  }

  public GetMembers(): string[] {
    return IsochroneArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Points: any[];
  public Duration: number;
  public EnableTraffic: boolean;
  public ProjCode: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
